import React from 'react'
import { ThemeProvider } from 'styled-components'
import { SoftConfigTheme } from '../../config'

interface Props extends Omit<React.ComponentProps<typeof ThemeProvider>, 'theme'> {
  theme: SoftConfigTheme
}

export const UILibraryThemeProvider: React.FC<Props> = (props) => <ThemeProvider {...props} />
